// store.js
import { configureStore } from '@reduxjs/toolkit';
import rootReducer from './reducers'; // Create your root reducer

const store = configureStore({
  reducer: rootReducer,
  // Add middleware or enhancers if needed
});

export default store;
